<card
    [changeModeFn]="changeModeFn"
    [showEditSaveButton]="showEditSaveButton$.source$ | async"
    [title]="'Site Settings'"
    [(mode)]="currentMode"
    [showSharedContent]="true"
    (save)="save.emit()"
>
    <card-shared-content>
        <div class="flex flex-col gap-medpace">
            @let site = site$ | async;
            @let siteCountry = siteCountry$ | async;

            <medpace-site-services-payment-validation
                [formGrp]="formGrp().controls.readyForPaymentValidationFormGroup"
                [mode]="currentMode()"
                [site]="site"
            />
            <medpace-site-services-specific-services
                [formGrp]="formGrp().controls.specificServices"
                [mode]="currentMode()"
                [site]="site"
            />

            <medpace-site-services-payment-options
                [formGrp]="formGrp().controls.paymentOptions"
                [mode]="currentMode()"
                [site]="site"
                [siteCountry]="siteCountry"
                [isPaymentEnabled]="(isAnyPaymentMethodEnabled$.source$ | async) ?? false"
            />

            <medpace-site-services-patient-pace-options
                [formGrp]="formGrp().controls.patientPaceOptions"
                [mode]="currentMode()"
                [site]="site"
            />
        </div>
    </card-shared-content>
</card>
